import { createSlice } from '@reduxjs/toolkit'

export type SettingsState = {
  is_export_ongoing: boolean
  show_export_ready_modal: boolean
  show_product_competition_list: boolean | undefined
  latest_export_result_code: -1 | 1
  latest_export_report_id: string | undefined
}

const initialState: SettingsState = {
  is_export_ongoing: false,
  latest_export_result_code: 1,
  latest_export_report_id: undefined,
  show_export_ready_modal: false,
  show_product_competition_list: true,
}

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setExportStatus: (
      state: SettingsState,
      {
        payload,
      }: {
        payload: {
          is_export_ongoing: boolean
          resultCode?: -1 | 1
          reportId?: string
        }
      },
    ) => {
      if (state.is_export_ongoing && !payload.is_export_ongoing) {
        state.show_export_ready_modal = true
      }
      state.is_export_ongoing = payload.is_export_ongoing
      if (payload.resultCode) {
        state.latest_export_result_code = payload.resultCode
      }
      if (payload.reportId) {
        state.latest_export_report_id = payload.reportId
      }
    },
    openExportReadyModal(state: SettingsState) {
      state.show_export_ready_modal = true
    },
    closeExportReadyModal(state: SettingsState) {
      state.show_export_ready_modal = false
    },
    setProductCompetition: (
      state: SettingsState,
      { payload }: { payload: boolean },
    ) => {
      state.show_product_competition_list = payload
    },
  },
})

export const { setExportStatus, setProductCompetition, closeExportReadyModal } =
  settingsSlice.actions

export default settingsSlice.reducer
